import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/ibm-aiops-training/ibm-aiops-training/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineNotification = makeShortcode("InlineNotification");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`The purpose of this guide is to provide a self-contained set of instructions to integrate with ServiceNow, summarizing instructions from `}<a href="https://www.ibm.com/docs/en/cloud-paks/cloud-pak-aiops/3.5.1?topic=connections-servicenow-connection" target="_blank">{`IBM Documentation`}</a>{`  and other sources.`}</p>
    <p>{`ServiceNow integrations provide historical and live data for change requests, incidents, and problems. ServiceNow integrations also provide inventory data for the ServiceNow observer.`}</p>
    <InlineNotification kind="error" mdxType="InlineNotification"> 
      <p><strong parentName="p">{`Important`}</strong></p>
      <p>{`You can only have one ServiceNow integration per instance.`}</p>
    </InlineNotification>
    <p>{`The instructions have been successfully tested against a ROKS cluster on the IBM Cloud.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      